import { axiosClient } from "./client";
import {CATEGORIES_GET, COUNTRIES_GET, GET_HOME_NOTICES, GET_LANGUAGES} from "./client/endpoints";

const fetchCountryList = async (): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(COUNTRIES_GET);
    return response.data;
  } catch (e) {
    return [];
  }
};

const fetchCategoryList = async (): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(CATEGORIES_GET);
    return response.data;
  } catch (e) {
    return [];
  }
};
const getHomeNotices = async (): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_HOME_NOTICES);
    return response.data;
  } catch (e) {
    return [];
  }
};

const getLanguages = async (): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(GET_LANGUAGES);
    return response.data.data.languages;
  } catch (e) {
    return [];
  }
};


const AppService = {
  fetchCountryList,
  fetchCategoryList,
  getHomeNotices,
  getLanguages
};

export default AppService;
